import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import ThanksModal from '../../../../../common/elements/ThanksModal';
import { FormFieldHelpers as Form } from '../../../../../../helpers/index';

class CreateThreadForm extends Component {
    render() {

        const { 
            handleSubmit, 
            isOpen, 
            handleClose 
        } = this.props;

        return (
            <div className="create-post">
                <form onSubmit={ handleSubmit } className="">
                    <div className="field-box">
                        <Field name="title" placeholder="Title..." component={ Form.textField } validate={ Form.validate( 'Title' ) } />
                    </div>
                    <div className="field-box">
                        <Field name="description" placeholder="Description..." style={ {minHeight: '200px'} } component={ Form.quill } />
                    </div>
                    <button id="post-thread-btn" className="btn btn-primary">
                        <span className="label">Post Thread</span>
                        <span><i className="fa fa-angle-right animated-right" /></span>
                        </button>
                </form>
                <ThanksModal isOpen={ isOpen } onClose={ (e) => handleClose(e) } message="Your thread has been submitted."/>
            </div>
        );
    };
}

CreateThreadForm.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    handleSubmit: PropTypes.func
}

CreateThreadForm = reduxForm( { form: 'create_thread' } )( CreateThreadForm );

export default CreateThreadForm;



// WEBPACK FOOTER //
// src/client/components/site/features/forums/pages/elements/CreateThreadForm.js